import * as React from 'react';
import "./sideMenu.less";
import { BEOMStore } from '../../data/dataStore';
import { currencyFormat, numberWithCommas } from '../../helpers';
import { TheBrain } from '../../data/brain';

export interface MenuProps {
    brain: TheBrain;
}




const ResultSection = (props: {
    heading: string,
    data: { title: string, subDetail?: string, detail: string }[],
    total?: string,
}) =>
    <div className="result-section">
        <div className="heading">{props.heading}</div>
        <table>
            <tbody>
                {props.data.map(d =>
                    <tr className="data" key={d.title}>
                        <td className="title">{d.title}</td>
                        <td className="subdetail">{d.subDetail}</td>
                        <td className="info">{d.detail}</td>
                    </tr>
                )}
                {!!props.total &&
                    <tr className="data ">
                        <td className="title total">TOTAL</td>
                        <td></td>
                        <td className="info total">{props.total}</td>
                    </tr>
                }
            </tbody>
        </table>
    </div>

const MoneyResultSection = (props: {
    heading: string,
    data: { title: string, count?: number, amount: number }[],
    total?: string,
}) => {
    const total = props.data
        .map(d => d.amount)
        .reduce((a, b) => a + b, 0);

    return <ResultSection
        heading={props.heading}
        data={props.data.map(d => ({
            title: d.title,
            subDetail: !!d.count ? numberWithCommas(d.count, 0) : "",
            detail: !!d.amount ? currencyFormat(d.amount) : "",
        }))}
        total={!!total ? currencyFormat(total) : ""}
    />
}

export const SideMenu = (props: MenuProps) => {

    const { brain, brain: { data: { info, spend, breakEven } } } = props;

    return <div className="side-menu">
        <div className="results-head">Results</div>
        <ResultSection
            heading="Info"
            data={[
                { title: "Band/artist name", detail: info.artistName },
                { title: "Genre", detail: info.genre },
                { title: "Single or album?", detail: info.format },
                { title: "Doing Physical?", detail: info.doingPhysical },
                { title: "Release name", detail: info.releaseName },
            ]}
        />
        <MoneyResultSection
            heading="Budget"
            data={[
                { title: "Recording", amount: spend.recording },
                { title: "Marketing/Promo", amount: spend.marketing },
                { title: "Manufacturing", amount: spend.manufacturing },
                { title: "Admin", amount: spend.admin },
                { title: "Anything else?", amount: spend.other },
            ]}
        />
        <MoneyResultSection
            heading="Targets"
            data={[
                { title: "Streams", amount: brain.getStreamingIncome(), count: brain.getStreamingUnits() },
                { title: "Track Downloads", amount: brain.getTrackDownloadIncome(), count: brain.getTrackDownloadUnits() },
                { title: "Album Downloads", amount: brain.getAlbumDownloadIncome(), count: brain.getAlbumDownloadUnits() },
                { title: "Physical", amount: brain.getPhysicalAlbumIncome(), count: brain.getPhysicalAlbumUnits() },
            ]}
        // total="fgfdsgdf"
        />

    </div>

}